import React from 'react';
import { ResponsiveLine } from '@nivo/line';
import _ from 'lodash';
import { groupKeys, isGroupKeyMatched, keysName } from '../../states/Utils';

export const NivoLineChart = ({ view, data }) => {
  const keys = groupKeys(data, view.config.group_by || []);
  const series = groupKeys(data, view.config.series || ['start']);
  const computed = data.data.map((group) => {
    return keys.map((k) => {
      let filtered = group.filter((v) => isGroupKeyMatched(v, k));
      let d = series.map((k) => ({
        x: keysName(data.meta, k),
        y: _.sum(filtered.filter((v) => isGroupKeyMatched(v, k)).map((v) => v.value)),
      }));
      let dd = group.filter((v) => isGroupKeyMatched(v, k)).map((v) => ({ x: v['start'], y: v['value'] }));
      return {
        id: keysName(data.meta, k),
        data: _.sortBy(d, [(v) => v.x]),
      };
    });
  });

  return <ResponsiveLine useMesh={true} {...view.config.props} data={computed[0]} />;
};
